import { render, staticRenderFns } from "./CoreCardLabel.vue?vue&type=template&id=75774fe2&scoped=true&"
import script from "./CoreCardLabel.vue?vue&type=script&lang=ts&"
export * from "./CoreCardLabel.vue?vue&type=script&lang=ts&"
import style0 from "./CoreCardLabel.vue?vue&type=style&index=0&id=75774fe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75774fe2",
  null
  
)

export default component.exports